module.exports = __webpack_public_path__ + "static/media/frank1932.5a619396.png";